export default __webpack_public_path__ + "static/media/CBD_logo_NL_white@2x.86a5147c.png";